import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { successToast } from "components/toast";
import { errorToast } from "components/toast";
import { getSettings } from "services/_settings";
import { updateSettings } from "services/_settings";
import TextEditor from "components/TextEditor";
import { getPermissions } from "context/AuthContext";

const Setting = () => {
  const Permissions = getPermissions();
  const [editData, setEditData] = useState({});
  const [media, setMedia] = useState({});

  const handleSubmit = async (values) => {
    const payload = {
      company_name: values.company_name,
      company_email: values.company_email,
      company_phone1: values.company_phone1,
      company_phone2: values.company_phone2,
      instagram_link: values.instagram_link,
      facebook_link: values.facebook_link,
      twitter_link: values.twitter_link,
      company_address: values.company_address,
      bio_name: values.bio_name,
      bio_description: values.bio_description,
      bio_designation: values.bio_designation,
      bio_contact: values.bio_contact,
      // bio_experience: values.bio_experience,
      bio_image: values.bio_image,
      disclaimer: values.disclaimer,
      survey_optional_test_button_label:
        values.survey_optional_test_button_label,
      survey_result_button_label: values.survey_result_button_label,
      survey_email_button_label: values.survey_email_button_label,
      survey_print_button_label: values.survey_print_button_label,
      media: media,
      iframe_enabled: values.iframe_enabled,
    };

    const data = await updateSettings(payload);
    if (data.data) {
      successToast(data.message);
    } else {
      errorToast(data.message);
    }
  };

  const getInitialData = async () => {
    const data = await getSettings();
    if (data.data) {
      const settingsData = data.data.reduce((acc, item) => {
        acc[item.key] = item.value;
        return acc;
      }, {});
      setEditData(settingsData);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  const settingSchema = Yup.object().shape({
    company_name: Yup.string().required("Company Name is required"),
    company_email: Yup.string()
      .email("Invalid email format")
      .required("Company Email is required"),
    company_phone1: Yup.string().optional(),
    company_phone2: Yup.string().optional(),
    company_address: Yup.string().optional(),
    instagram_link: Yup.string().url("Invalid URL").optional(),
    facebook_link: Yup.string().url("Invalid URL").optional(),
    twitter_link: Yup.string().url("Invalid URL").optional(),
    bio_name: Yup.string().required("Bio Name is required"),
    bio_description: Yup.string().required("Bio Description is required"),
    bio_designation: Yup.string().required("Bio Designation is required"),
    bio_contact: Yup.string().required("Bio Contact is required"),
    // bio_experience: Yup.string().required("Bio experience is required"),
    bio_image: Yup.string().optional().nullable(),
    disclaimer: Yup.string().optional(),
    survey_optional_test_button_label: Yup.string().required(
      "Optional Test Label is required",
    ),
    survey_result_button_label: Yup.string().required(
      "Result Button Label is required",
    ),
    survey_email_button_label: Yup.string().required(
      "Email Button Label is required",
    ),
    survey_print_button_label: Yup.string().required(
      "Print Button Label is required",
    ),
  });

  const bioImagePath = editData?.bio_image;
  const imageName = bioImagePath
    ? bioImagePath.split("/").pop()
    : "default_image.png";

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Settings</h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    company_name: editData?.company_name || "",
                    company_email: editData?.company_email || "",
                    company_phone1: editData?.company_phone1 || "",
                    company_phone2: editData?.company_phone2 || "",
                    instagram_link: editData?.instagram_link || "",
                    facebook_link: editData?.facebook_link || "",
                    twitter_link: editData?.twitter_link || "",
                    company_address: editData?.company_address || "",
                    bio_name: editData?.bio_name || "",
                    bio_description: editData?.bio_description || "",
                    bio_designation: editData?.bio_designation || "",
                    bio_contact: editData?.bio_contact || "",
                    // bio_experience: editData?.bio_experience || "",
                    bio_image: null,
                    disclaimer: editData?.disclaimer || "",
                    survey_optional_test_button_label:
                      editData?.survey_optional_test_button_label || "",
                    survey_result_button_label:
                      editData?.survey_result_button_label || "",
                    survey_email_button_label:
                      editData?.survey_email_button_label || "",
                    survey_print_button_label:
                      editData?.survey_print_button_label || "",
                    iframe_enabled: editData?.iframe_enabled || "false",
                  }}
                  validationSchema={settingSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, setFieldValue, handleChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="pl-lg-4">
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-company_name"
                              >
                                Company Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-company_name"
                                name="company_name"
                                placeholder="Enter Company name"
                                type="text"
                                value={values.company_name}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="company_name"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-company_email"
                              >
                                Company email{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-company_email"
                                name="company_email"
                                placeholder="Enter company email"
                                type="text"
                                value={values.company_email}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="company_email"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-company_phone1"
                              >
                                Company Phone 1
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-company_phone1"
                                name="company_phone1"
                                placeholder="Enter company phone1"
                                type="text"
                                value={values.company_phone1}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="company_phone1"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-company_phone2"
                              >
                                Company Phone 2
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-company_phone2"
                                name="company_phone2"
                                placeholder="Enter company phone2"
                                type="text"
                                value={values.company_phone2}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="company_phone2"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-company_address"
                              >
                                Company Address
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-company_address"
                                name="company_address"
                                placeholder="Enter company address"
                                rows="3"
                                type="textarea"
                                value={values.company_address}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="company_address"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="12">
                            <FormGroup>
                              <label className="form-control-label">
                                Disclaimer
                              </label>
                              <div className="custom-quill">
                                <TextEditor
                                  value={values.disclaimer}
                                  onChange={(val) =>
                                    setFieldValue("disclaimer", val)
                                  }
                                  placeholder="Enter disclaimer..."
                                  height={250}
                                />
                              </div>
                              <ErrorMessage
                                name="disclaimer"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      <hr className="my-2 mx-4" />
                      <div className="pl-lg-4">
                        <h3 className="text-muted my-3 ">Social Links</h3>
                        <Row>
                          <Col lg="4">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-facebook_link"
                              >
                                Facebook link
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-facebook_link"
                                name="facebook_link"
                                placeholder="Enter facebook link"
                                type="text"
                                value={values.facebook_link}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="facebook_link"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="4">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-twitter_link"
                              >
                                Twitter Link
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-twitter_link"
                                name="twitter_link"
                                placeholder="Enter twitter link"
                                type="text"
                                value={values.twitter_link}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="twitter_link"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="4">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-instagram_link"
                              >
                                Instagram link
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-instagram_link"
                                name="instagram_link"
                                placeholder="Enter instagram link"
                                type="text"
                                value={values.instagram_link}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="instagram_link"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      <hr className="my-2 mx-4" />
                      <div className="pl-lg-4">
                        <h3 className="text-muted my-3 ">Bio </h3>

                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-bio_name"
                              >
                                Bio name
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-bio_name"
                                name="bio_name"
                                placeholder="Enter bio name"
                                type="text"
                                value={values.bio_name}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="bio_name"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-bio_designation"
                              >
                                Bio Designation
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-bio_designation"
                                name="bio_designation"
                                placeholder="Enter bio designation"
                                type="text"
                                value={values.bio_designation}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="bio_designation"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        {/* <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-bio_experience"
                              >
                                Bio Experience
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-bio_experience"
                                name="bio_experience"
                                placeholder="Enter bio experience"
                                type="string"
                                value={values.bio_experience}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="bio_experience"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col> */}

                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-bio_contact"
                              >
                                Bio Contact
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-bio_contact"
                                name="bio_contact"
                                placeholder="Enter bio contact"
                                type="text"
                                value={values.bio_contact}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="bio_contact"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-image"
                              >
                                Bio Image
                              </label>
                              <div
                                className="form-control rounded-0 rounded-end"
                                style={{
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                              >
                                {imageName}
                              </div>
                              <Input
                                className="form-control-alternative"
                                id="input-image"
                                name="image"
                                type="file"
                                style={{
                                  color: "#90a4ae",
                                  backgroundColor: "white",
                                  boxShadow:
                                    "0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)",
                                  border: 0,
                                  height: "43px",
                                  padding: "5px 0 5px 5px",
                                  margin: "0",
                                  lineHeight: "28px",
                                  borderRadius: "5px",
                                  overflow: "hidden",
                                }}
                                onChange={(event) => {
                                  const file = event.currentTarget.files[0];
                                  if (file) {
                                    const reader = new FileReader();
                                    reader.onload = () => {
                                      const base64Raw =
                                        reader.result.split(",")[1];
                                      const fileObj = {
                                        fileName: file.name,
                                        fileData: base64Raw,
                                      };
                                      setMedia(fileObj);
                                      setFieldValue("image", file);
                                    };
                                    reader.readAsDataURL(file);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="image"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label className="form-control-label">
                                Bio Description
                                <span style={{ color: "red" }}> *</span>
                              </label>
                              <div className="custom-quill">
                                <TextEditor
                                  value={values.bio_description}
                                  onChange={(val) =>
                                    setFieldValue("bio_description", val)
                                  }
                                  placeholder="Enter Detailed bio description..."
                                  height={400}
                                />
                              </div>
                              <ErrorMessage
                                name="bio_description"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      <hr className="my-2 mx-4" />
                      <div className="pl-lg-4">
                        <h3 className="text-muted my-3">
                          Survey page Button Labels
                        </h3>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label">
                                Optional Test Button Label
                              </label>
                              <Input
                                className="form-control-alternative"
                                name="survey_optional_test_button_label"
                                placeholder="Enter label"
                                type="text"
                                value={values.survey_optional_test_button_label}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="survey_optional_test_button_label"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label">
                                Result Button Label
                              </label>
                              <Input
                                className="form-control-alternative"
                                name="survey_result_button_label"
                                placeholder="Enter label"
                                type="text"
                                value={values.survey_result_button_label}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="survey_result_button_label"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label">
                                Email Button Label
                              </label>
                              <Input
                                className="form-control-alternative"
                                name="survey_email_button_label"
                                placeholder="Enter label"
                                type="text"
                                value={values.survey_email_button_label}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="survey_email_button_label"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label">
                                Print Button Label
                              </label>
                              <Input
                                className="form-control-alternative"
                                name="survey_print_button_label"
                                placeholder="Enter label"
                                type="text"
                                value={values.survey_print_button_label}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="survey_print_button_label"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      <hr className="my-2 mx-4" />
                      <div className="pl-lg-4">
                        <h3 className="text-muted my-3">
                          Organisation Control
                        </h3>

                        <Row className="align-items-center my-3">
                          <Col lg="6">
                            <FormGroup>
                              <label className="form-control-label">
                                SAA Iframe
                              </label>

                              <div className="custom-control custom-switch">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="iframeToggle"
                                  checked={values.iframe_enabled === "true"}
                                  onChange={(e) => {
                                    setFieldValue(
                                      "iframe_enabled",
                                      e.target.checked ? "true" : "false",
                                    );
                                  }}
                                />

                                <label
                                  className="custom-control-label"
                                  htmlFor="iframeToggle"
                                  style={{ fontWeight: 600 }}
                                >
                                  {values.iframe_enabled === "true"
                                    ? "Enable"
                                    : "Disable"}
                                </label>
                              </div>

                              <ErrorMessage
                                name="iframe_enabled"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                      {Permissions.includes("update-settings") && (
                        <div className="pl-lg-4">
                          <Button color="primary" type="submit">
                            Save
                          </Button>
                        </div>
                      )}
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Setting;
